import { render, staticRenderFns } from "./OrderSuccessUpi.vue?vue&type=template&id=3df3c695&"
import script from "./OrderSuccessUpi.vue?vue&type=script&lang=js&"
export * from "./OrderSuccessUpi.vue?vue&type=script&lang=js&"
import style0 from "./OrderSuccessUpi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports